import axios from 'axios';
const md5 = require('md5');
const apis = require('./apis');
const Host = require('./hosts');
const { tokenConfig } = Host(process.env.NODE_ENV)

class Request {

  constructor() {
    this.axios = axios
    this.apis = apis
    this.requestInterCeptors()
    this.responseInterCeptors()
  }

  requestInterCeptors() {
    this.axios.interceptors.request.use((config) => {
      if (config.sign) {
        config.headers = Object.assign(this.createSign(config.data), config.headers)
      }
      if(!config.isNotAppcode){
        if(config.headers) {
          config.headers.appcode = 'com.rjhy.uranus'
        } else {
          config.headers = {
            appcode : 'com.rjhy.uranus'
          }
        }
        if(config.appcode){
          config.headers.appcode = config.appcode
        }
      }
      // console.log('config', config )
      return config;
    }, function (error) {
      return Promise.reject(error);
    })
  }

  responseInterCeptors() {
    this.axios.interceptors.response.use(response => {
      // console.log(response.data, '========response.data')
      if (response.data.data) {
        if (response.data.totalCount) return response.data
        return response.data.data
      }
      return response.data
    })
  }

  createSign(params,isGw) {
    let valueArr = [];
    const signStr = isGw ? 'dac3ef6859f44e439c88cbc28d65880a' : 'sjdxfnqogbzoun13d971ckh8p';
    console.log('当前=====',signStr)
    if (params) {
      const sortedObjKeys = Object.keys(params).sort();
      for (let index in sortedObjKeys) {
        valueArr.push(params[sortedObjKeys[index]]);
      }
    }
    let timestamp = new Date().getTime();
    const sign = md5(signStr + valueArr.join('') + timestamp);
    let headers = {
      signature: sign,
      timestamp: timestamp
    };
    return headers;
  }

  get(opt) {
    const {url, sign = true, params = {}, headers = {}} = opt
    return this._request({
      url,
      method: 'get',
      sign,
      params,
      headers
    })
  }

  _get (url, params, sign = false,isGw,appcode,appver) {
    console.log('当前的===url',url)
    let headers = {}
    if(sign) {
      headers = this.createSign(params,isGw)
    }
    if(appver){
      headers.appVersion = '4.17.0'
    }
    Object.keys(params)
      .forEach((key, idx) => {
        if(idx === 0) url += `?${key}=${params[key]}`
        else url += `&${key}=${params[key]}`
      })
    return this._request({
      url,
      method: 'GET',
      headers,
      appcode
    })
  }
  
  post(opt) {
    const {url, sign = true, params = {}, headers = {}} = opt
    return this._request({
      url,
      method: 'post',
      sign,
      data: params,
      headers
    })
  }
  _request(opt) {
    const { method } = opt
    let header = { }
    if (method === 'get') {
      header = { 'Accept': 'application/json' }
    } else {
      header = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
    opt.headers = Object.assign(header, opt.headers)
    return this.axios.request(opt)
  }
}

export const rjhySms = axios.create({
  baseURL: apis.rjhySms,
  timeout: 50000,
  headers: {}
})

export const rjhyUser = axios.create({
  baseURL: apis.rjhyUser,
  timeout: 50000,
  headers: {}
})

export const rjhyCircle = axios.create({
  baseURL: apis.rjhyCircle,
  timeout: 50000,
  headers: {}
})
export const getToken = async()=>{
 const data = await axios.post(apis.quote.getToken,tokenConfig,{headers:{"Content-Type": "application/json"}})
 return data.Data.Token
}
export const getHqInfo = async(params,token)=>{
  const isNotAppcode = true
  return await axios({method:'get',url:apis.quote.getKline,params,headers:{token},isNotAppcode})
 }

export const request =  new Request()

const services = [rjhySms, rjhyUser, rjhyCircle]

services.forEach(service => {
  service.interceptors.request.use((config) => {
    if(!config.isNotAppcode){
      if(config.headers) {
        config.headers.appcode = 'com.rjhy.uranus'
      } else {
        config.headers = {
          appcode : 'com.rjhy.uranus'
        }
      }
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
  })

  service.interceptors.response.use(response => {
    if (response.status == 200) {
      return response.data;
    }
  }, error => Promise.reject(error))
})
